var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"d-inline",on:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},[_c('quantity',{model:{value:(_vm.newQuantity),callback:function ($$v) {_vm.newQuantity=$$v},expression:"newQuantity"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }